import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './context/AuthContext';
import { PageLoaderProvider } from './context/PageLoaderContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import ComboDetail from './pages/ComboDetail';
import Cart from './pages/Cart';
import Wishlist from './pages/Wishlist';
import MyOrders from './pages/MyOrders';
import OrderDetail from './pages/OrderDetail';
import Checkout from './pages/Checkout';
import ReturnRequest from './pages/ReturnRequest';
import MyReturns from './pages/MyReturns';
import ReturnDetail from './pages/ReturnDetail';
import Profile from './pages/Profile';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Store from './pages/Store';
import About from './pages/About';
import Shipping from './pages/Shipping';
import ReturnsPolicy from './pages/ReturnsPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <AuthProvider>
      <PageLoaderProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route index element={<Home />} />
          <Route path="products" element={<Products />} />
          <Route path="products/:id" element={<ProductDetail />} />
          <Route path="combos" element={<Navigate to="/products?filter=combo" replace />} />
          <Route path="combos/:id" element={<ComboDetail />} />
          <Route path="contact" element={<Store />} />
          <Route path="about" element={<About />} />
          <Route path="shipping" element={<Shipping />} />
          <Route path="returns-policy" element={<ReturnsPolicy />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<TermsOfService />} />
          <Route
            path="cart"
            element={
              <PrivateRoute>
                <Cart />
              </PrivateRoute>
            }
          />
          <Route
            path="wishlist"
            element={
              <PrivateRoute>
                <Wishlist />
              </PrivateRoute>
            }
          />
          <Route
            path="orders"
            element={
              <PrivateRoute>
                <MyOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="orders/:id"
            element={
              <PrivateRoute>
                <OrderDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="checkout"
            element={
              <PrivateRoute>
                <Checkout />
              </PrivateRoute>
            }
          />
          <Route
            path="returns/request/:orderId"
            element={
              <PrivateRoute>
                <ReturnRequest />
              </PrivateRoute>
            }
          />
          <Route
            path="returns/:orderId/:itemId"
            element={
              <PrivateRoute>
                <ReturnRequest />
              </PrivateRoute>
            }
          />
          <Route
            path="returns"
            element={
              <PrivateRoute>
                <MyReturns />
              </PrivateRoute>
            }
          />
          <Route
            path="returns/detail/:id"
            element={
              <PrivateRoute>
                <ReturnDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
        </Route>
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
      </PageLoaderProvider>
    </AuthProvider>
  );
}

export default App;

